import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type cacheFirstResponder from '../impl/cacheFirst';
import type oAuthTokenResponder from '../impl/cacheOAuth';
import type fetchToCacheResponder from '../impl/fetchToCache';
import type headerAppendResponder from '../impl/headerAppend';
import type keepAliveResponder from '../impl/keepAlive';
import type logDiagnosticsResponder from '../impl/logDiagnostics';
import type preCacheResponder from '../impl/preCache';
import type zipRelativePathResponder from '../impl/zipPathRelative';

export interface MESSAGE_INTERFACES {
    AddCacheFirst: typeof cacheFirstResponder;
    AddHeader: typeof headerAppendResponder;
    AddOAuthTokenCache: typeof oAuthTokenResponder;
    AddPreCache: typeof preCacheResponder;
    AddZipPathRelativeResponder: typeof zipRelativePathResponder;
    AddKeepAliveMessageResponder: typeof keepAliveResponder;
    LogDiagnostics: typeof logDiagnosticsResponder;
    FetchToCache: typeof fetchToCacheResponder;
}

export interface IMessageInstantiator {
    allInterfaces: <K extends keyof MESSAGE_INTERFACES>() => K[];
    message: <K extends keyof MESSAGE_INTERFACES, V extends MESSAGE_INTERFACES[K]>(name: K) => V;
}

export const TYPES = {
    IMessageInstantiator: Symbol.for('IMessageInstantiator'),
};

export function injectMessageInstantiator(
    container: IContainer = injectOrBuildContainer(),
): IMessageInstantiator {
    return container.get<IMessageInstantiator>(TYPES.IMessageInstantiator);
}

export function bindMessageInstantiator(
    val: IMessageInstantiator,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IMessageInstantiator>(TYPES.IMessageInstantiator, val);
}

export function unbindMessageInstantiator(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IMessageInstantiator);
}
